<div class="container">
    <br><br><br>
    <div class="row justify-content-center" *ngIf="!codeItem">
        <div class="col-lg-4 col-md-6 col-12">
            <input type="text" class="form-control" placeholder="กรอกโค๊ด" #code>
            <br>
            <button class="btn btn-primary w-100" (click)="GetCode(code)">ตรวจสอบโค๊ด</button>
        </div>
    </div>
    <br>
    <div class="row justify-content-center" *ngIf="codeItem">
        <div class="col-lg-4 col-md-6 col-12 text-center">
            <div class="card p-3">
                <h3>รับสิทธิ์</h3>
                <p>{{codeItem.RewardName || codeItem.ItemName}}</p>
                <button class="btn btn-primary" (click)="close()">ปิด</button>
            </div>
        </div>
    </div>
</div>